import * as IoC from 'typescript-ioc';
import * as mobx from 'mobx';
import { IZoomDAO, IZoomGroupDTO } from '../../../api/zoom.dao';
import { ICookiesService } from '../../../infrastructure/cookies';
import { EXTRA_OPTION_ID, RADIX_PARAM, ZERO_OPTION_ID } from '../../../constants/common.constants';

class SelectGroupsVM {
    @mobx.observable
    private groupList: IZoomGroupDTO[];

    private isPickingGroups: boolean;

    constructor(@IoC.Inject private readonly zoomDAO: IZoomDAO,
                @IoC.Inject private readonly cookiesService: ICookiesService) {
    }

    public getGroupsList() {
        const listToReturn = this.groupList;
        if (!listToReturn && !this.isPickingGroups) {
            this.pickGroups();
            return;
        }

        return listToReturn;
    }

    public getGroupNameById = (id: number): string => {
        const list = this.getGroupsList();
        return list?.find(g => g.zoomGroupId === id)?.name;
    };

    /**
     * Get groupId from cookie if set or use defaults - EXTRA_OPTION_ID
     * @return {number}
     */
    @mobx.action
    public getDefaultGroupId = () => {
        const id = this.cookiesService.getCookie('zoomGroupId');
        if (!!id) {
            const newGroupId = parseInt(id, RADIX_PARAM);
            if (!isNaN(newGroupId) && this.groupList.find(g => g.zoomGroupId === newGroupId)) {
                return newGroupId;
            }
        }
        return EXTRA_OPTION_ID;
    };

    @mobx.action
    public getDefaultWebinarGroupId = () => {
        const id = this.cookiesService.getCookie('zoomWebinarGroupId');
        if (!!id) {
            const newGroupId = parseInt(id, RADIX_PARAM);
            if (!isNaN(newGroupId) && this.groupList.find(g => g.zoomGroupId === newGroupId)) {
                return newGroupId;
            }
        }
        return EXTRA_OPTION_ID;
    };

    @mobx.action
    public setGroupIdToCookie = (value: number) => {
        this.cookiesService.setCookie( {
            value: value.toString(),
            name: 'zoomGroupId'
        });
    };

    @mobx.action
    public setWebinarGroupIdToCookie = (value: number) => {
        this.cookiesService.setCookie( {
            value: value.toString(),
            name: 'zoomWebinarGroupId'
        });
    };

    @mobx.action
    public async pickGroups() {
        if (this.groupList) return;

        this.isPickingGroups = true;
        try {
            const groupsDTO = await this.zoomDAO.getGroups();
            groupsDTO.unshift({
                name: '(Any group)',
                zoomGroupId: EXTRA_OPTION_ID
            });
            groupsDTO.push({
                name: '(None)',
                zoomGroupId: ZERO_OPTION_ID
            });
            this.processGroupsResult(groupsDTO);
        } catch (e) {
            this.isPickingGroups = false;
        }
    }

    @mobx.action
    private processGroupsResult(groupsList: IZoomGroupDTO[]) {
        this.groupList = groupsList;
        this.isPickingGroups = false;
    }
}

export { SelectGroupsVM };
